(function () {
    'use strict';

    angular.module('swif.framework')
    .factory('$exceptionHandler', exceptionHandler);

    function exceptionHandler(errorMsgService) {
        'ngInject';
        return function (exception, cause) {

            if (exception) {
                errorMsgService.logToSentry(exception);
                if (_.contains(exception.message, '[$sanitize:badparse]')) {
                    console.log(exception.stack);
                    return;
                }
            }
            errorMsgService.addError({
                exception: exception,
                message: exception.stack,
                status: exception.message,
                statusText: cause,
                swif: {
                    type: 'JavaScript'
                }
            });
            console.log(exception.stack);
        };
    }

})();
